// extracted by mini-css-extract-plugin
module.exports = {"pricing":"Pricing_pricing__17_Cu"};